<template>
  <view-container
    title="Memberkit"
    class="view-memberkit"
    subtitle="Integre sua área de membros da plataforma Memberkit à Blitzpay."
    :breadcrumbs="breadcrumbs"
  >
    <table-header @add="add" @dispatch="dispatch" @searching="searching" />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-9"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.png"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <div v-else>
        <data-table
          new-design
          class="d-none d-lg-block"
          columnsFr="1fr 0.5fr 0.5fr 0.5fr 0.3fr"
          :columns="columns"
          :data="integrationList"
        >
          <template #default="{ item }">
            <div class="crop">
              {{ item.product_name }}
            </div>
            <div>
              {{ item.classroom }}
            </div>
            <div>
              {{ item.membership_level_id }}
            </div>
            <div>
              <strong :class="item.status ? 'text-success' : 'text-danger'">
                {{ item.status ? "Ativo" : "Inativo" }}
              </strong>
            </div>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          new-design
          class="d-lg-none"
          :columns="['', '', '']"
          :data="integrationList"
        >
          <template #default="{ item }">
            <div class="responsive-table">
              <small>
                <strong>Produto: </strong>
                {{ item.product_name }}
              </small>
              <small>
                <strong>ID Turma: </strong>
                {{ item.classroom }}
              </small>
              <small>
                <strong>ID Assinatura: </strong>
                {{ item.membership_level_id }}
              </small>
              <small>
                <strong>Status: </strong>
                <strong :class="item.status ? 'text-success' : 'text-danger'">
                  {{ item.status ? "Ativo" : "Inativo" }}
                </strong>
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
      </div>
      <!-- Mobile area -->
    </template>

    <div class="d-flex justify-content-end my-5">
      <paginator
        v-show="integrationList.length"
        ref="paginator"
        :pagination="pagination"
        @on-update="dispatch"
      />
    </div>

    <integration-modal
      v-model="modal"
      title="Memberkit"
      link="https://memberkit.com/"
    >
      <memberkit-modal
        :integrationToEdit="integrationToEdit"
        @close="modal = false"
        @update-list="dispatch"
      />
    </integration-modal>
  </view-container>
</template>
<script>
import MemberkitModal from "@/components/tools/modals/member-area/Memberkit.vue";

import IntegrationsMixin from "@/mixins/integration";

export default {
  mixins: [IntegrationsMixin],
  components: {
    MemberkitModal
  },
  data() {
    return {
      integration: "memberkit",
      columns: ["Produto", "ID Turma", "ID Assinatura", "Status", ""],
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Área de membros", link: "tools-member-area" },
        { title: "Memberkit" }
      ]
    };
  }
};
</script>
